import { render, staticRenderFns } from "./MyConfirm.vue?vue&type=template&id=6e4108e2&"
import script from "./MyConfirm.vue?vue&type=script&lang=js&"
export * from "./MyConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MyConfirm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports